<script>
  export default {
    mounted() {
      $('body').addClass('gray-bg');
    }
  }
</script>

<template>
  <div class="middle-box text-center animated fadeInDown">
    <h1>404</h1>
    <h3 class="font-bold">Página não encontrada</h3>
    
    <p class="error-desc">
      Desculpe, mas a página que você está procurando foi não encontrada.
    </p>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/404/componentes/PaginaNaoEncontrada.vue